import { isDOOHCampaign } from 'sonata-static-storage/lib/helpers/campaign.helpers';

import TargetingProvider from '@/contexts/Targeting/TargetingProvider';
import { EMPTY_DOOH_AUDIENCE } from '@/helpers/doohAudience/doohAudience.helper';
import Demography from './Demography';
import DoohDemography from './Dooh/DoohDemography';

import type { CampaignFamilyEnum } from 'sonata-static-storage/lib/schemas/campaign/campaign.schema';
import type { TargetingBaseType } from 'sonata-static-storage/lib/schemas/targeting/TargetingBaseType';
import type { UserInterface } from 'sonata-static-storage/lib/schemas/user/user.schema';
import type { UserRoleInterface } from 'sonata-static-storage/lib/schemas/user/userRole.schema';
import type { DoohAudience } from '@/services/doohAudience.service';

type Props = {
  country?: string;
  doohAudience?: DoohAudience;
  familyType?: CampaignFamilyEnum;
  /** DOOH only: a finished entity, whose audience can no longer change */
  isReadOnly?: boolean;
  onChange: (targeting: TargetingBaseType) => void;
  onDoohAudienceChange?: (doohAudience: DoohAudience) => void;
  targeting: TargetingBaseType;
  user: UserInterface;
  userRoles: UserRoleInterface[];
};

/** The demography of the entity channel: the targeting one (digital / CTV) or the DOOH audience target */
function DemographyWrapper({
  country,
  doohAudience = EMPTY_DOOH_AUDIENCE,
  familyType,
  isReadOnly,
  onChange,
  onDoohAudienceChange,
  targeting,
  user,
  userRoles
}: Props) {
  if (familyType && isDOOHCampaign(familyType) && onDoohAudienceChange) {
    return (
      <DoohDemography
        country={country}
        doohAudience={doohAudience}
        isReadOnly={isReadOnly}
        onChange={onDoohAudienceChange}
      />
    );
  }

  return (
    <TargetingProvider onChange={onChange} targeting={targeting} user={user} userRoles={userRoles}>
      <Demography />
    </TargetingProvider>
  );
}

export default DemographyWrapper;
